import React from 'react';

import './style.sass';

type Props = React.PropsWithChildren<{
    className?: string,
    title: string,
}>;

export const CardProperty = ({ className, title, children }: Props) => {
    return (
        <div className={`card-property ${className ? className : ''}`}>
            <span className="p2-regular grey-1">{title}</span>
            {children}
        </div>
    );
};
